import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DoctorBillingService } from 'app/modules/fuse/services/doctor-billing.service';

@Component({
    selector: 'app-cerrarfacturacion-modal',
    templateUrl: './cerrarfacturacion-modal.component.html',
    styleUrls: ['./cerrarfacturacion-modal.component.scss'],
    standalone: false
})
export class CerrarfacturacionModalComponent implements OnInit {

  cerrarfacturacionFormGroup:  UntypedFormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<CerrarfacturacionModalComponent>,  
  public doctorBillingService: DoctorBillingService,
  public fb: UntypedFormBuilder,
  private sharedService: SharedService) { }

  ngOnInit(): void {
    this.cerrarfacturacionFormGroup = this.fb.group({
      Date: [{value: ''}, Validators.required],  
    });
  }

  cerrarfacturacion(){
    if (this.cerrarfacturacionFormGroup.invalid) {
      this.showInvalidFormControls(this.cerrarfacturacionFormGroup);
      return;
    }
    let model = this.cerrarfacturacionFormGroup.value;
    const date = (model.Date !== null && model.Date.value != "") ? DateHelper.getUTCDateString(DateHelper.getNativeDate(model.Date)) : null;
    this.doctorBillingService.Cerrarfacturacion(date)
        .subscribe(res => {
          if (res.result == 1 && res.code === 0) {
            this.sharedService.ShowSnackBar('Se ha traspasado la deuda a la facturación del médico correctamente, y se ha cerrado el mes.', 'Okay', 2000);
            this.dialogRef.close();
          }else{
            this.sharedService.ShowSnackBar('error');
          }
        }, err => {
          this.sharedService.ShowSnackBar('error');
          console.error(err);
        });
  }

  cancel(){
    this.dialogRef.close();
  }

  showInvalidFormControls(formGroup: UntypedFormGroup) {
    if (formGroup !== undefined) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            control.markAsDirty({ onlySelf: true });
            control.markAsTouched({ onlySelf: true });
        });
    }
  }

}
